<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <fieldset>
                        <legend>Name</legend>
                        <input v-model="modifiedScene.name" type="textarea" />
                    </fieldset>
                    <fieldset>
                        <legend>Image</legend>
                        <img :src="modifiedScene.stage.elements[0].asset.src" @click="onImageClicked" />
                    </fieldset>
                    <fieldset>
                        <legend>Grid Size (Pixels)</legend>
                        <input v-model.number="modifiedScene.stage.grid.size" type="number" />
                    </fieldset>
                    <fieldset>
                        <legend>Grid Type</legend>
                        <input v-model="modifiedScene.stage.grid.type" type="textarea" disabled />
                    </fieldset>
                    <fieldset>
                        <legend>Width</legend>
                        <input v-model="modifiedScene.stage.bounds.se.q" type="textarea" disabled />
                    </fieldset>
                    <fieldset>
                        <legend>Height</legend>
                        <input v-model="modifiedScene.stage.bounds.se.r" type="textarea" disabled />
                    </fieldset>
                    <button @click="onSave">{{ saveButton }}</button>
                    <button @click="onCancel">Cancel</button>
                    <button v-show="showDelete" @click="onDelete">Delete</button>
                    <MapLibrary ref="mapSelector" @onMapChosen="onMapChosen" v-show="showMapSelector" />
                </div>
            </div>
        </div>
    </transition>
</template>

<style scoped>
img {
    width: 250px;
    height: 100px;
    object-fit: cover;
}
</style>

<script lang="ts">
import * as jsonpatch from 'fast-json-patch';
import _ from 'lodash';

import MapLibrary from '@/components/library/maps/MapLibrary.vue';
import { SCENE } from '@/core/scene/constants.js';

const defaultScene = {
    id: 'default',
    name: 'default',
    stage: {
        grid: { type: 'square' },
        bounds: { se: { q: 0, r: 0 } },
        elements: [
            {
                asset: { kind: 'image', src: '/static/assets/marc.png' },
            },
        ],
    },
};

function getImageDimensions(src) {
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.onload = () => resolve({ width: image.width, height: image.height });
        image.onerror = reject;
        image.src = src;
    });
}

export default {
    components: {
        MapLibrary: MapLibrary,
    },
    data: function() {
        return {
            showMapSelector: false,
            scene: null,
            modifiedScene: defaultScene,
            saveButton: 'Save',
            showDelete: false,
        };
    },
    watch: {
        scene: function() {
            if (this.scene) {
                this.modifiedScene = _.cloneDeep(this.scene);
            }
        },
    },
    methods: {
        onImageClicked() {
            this.$refs.mapSelector.map = this.modifiedScene.stage.elements[0].asset.src;
            this.showMapSelector = true;
        },
        onMapChosen({ map }) {
            this.showMapSelector = false;
            this.modifiedScene.stage.elements[0].asset.src = map.asset.src;
        },
        async onSave() {
            if (
                this.scene.stage.elements[0].asset.src !== this.modifiedScene.stage.elements[0].asset.src ||
                this.scene.stage.grid.size !== this.modifiedScene.stage.grid.size
            ) {
                const dim = await getImageDimensions(this.modifiedScene.stage.elements[0].asset.src);
                this.modifiedScene.stage.bounds.se = {
                    q: Math.floor(dim['width'] / (this.modifiedScene.stage.grid.size * (SCENE.MAGIC_SCALE / 50))),
                    r: Math.floor(dim['height'] / (this.modifiedScene.stage.grid.size * (SCENE.MAGIC_SCALE / 50))),
                };
            }
            if (this.scene._id) {
                const patch = jsonpatch.compare(this.scene, this.modifiedScene);
                if (patch.length > 0) {
                    this.$emit('onChange', { id: this.scene._id, patch: patch });
                    this.scene = null;
                }
            } else {
                this.$emit('onAdd', { scene: this.modifiedScene });
                this.scene = null;
            }
        },
        onCancel() {
            this.scene = null;
            this.$emit('onCancel', {});
        },
        onDelete() {
            const sceneId = this.scene._id;
            this.scene = null;
            this.$emit('onDelete', { sceneId });
        },
    },
};
</script>
